export class ManualUnschedulerRecursionRuleModel {
    Id: number;
    RecurrenceType: string;
    RecurrenceInterval: number;
    DaysOfWeek: string | null;
    EndDate: string;
    CreatedOn: Date;
    UpdatedOn: Date;
    FirstWeekdayMonthlyRecurrence : boolean;
    RecursionRuleExceptionDates : Date[];
    FirstWeekdayOfMonth: boolean;
    FirstOccurrenceOfWeekdayInMonth: boolean;

    constructor(obj: any){
        this.Id = obj?.Id ?? obj?.id ?? 0;
        this.RecurrenceType = obj?.RecurrenceType ?? obj?.recurrenceType ?? '';
        this.RecurrenceInterval = obj?.RecurrenceInterval ?? obj?.recurrenceInterval ?? 0;
        this.DaysOfWeek = obj?.DaysOfWeek ?? obj?.daysOfWeek ?? null;
        this.EndDate = obj?.EndDate ?? obj?.endDate ??  new Date().toDateString();
        this.CreatedOn = obj?.CreatedOn ?? (obj?.createdOn && new Date(obj?.createdOn)) ?? new Date();
        this.UpdatedOn = obj?.UpdatedOn ?? (obj?.updatedOn && new Date(obj?.updatedOn)) ?? new Date();
        this.FirstWeekdayMonthlyRecurrence = obj?.firstWeekdayMonthlyRecurrence ?? false;
        this.RecursionRuleExceptionDates = obj?.recursionRuleExceptionDates ?? Array(0);
        this.FirstWeekdayOfMonth = (this.FirstWeekdayMonthlyRecurrence && this.RecurrenceType == 'MONTHLY' && this.DaysOfWeek == null);
        this.FirstOccurrenceOfWeekdayInMonth = (this.FirstWeekdayMonthlyRecurrence && this.RecurrenceType == 'MONTHLY' && this.DaysOfWeek != null);
    }
}